import axios from "axios";
import query from "./constants.api";

const axiosInstance = async (method, url, data, type, baseUrl) => {
    const token = await new Promise((resolve) => {
        const interval = setInterval(() => {
            const value = localStorage.getItem('unified_nova_accessToken');
            if (value) {
                clearInterval(interval);
                resolve(value);
            }
        }, 100); // Check every 100ms
    });

    const headers = {
        Authorization: token,
    };

    let config = {
        method: method ? method : 'GET',
        baseURL: baseUrl ? baseUrl : query.baseURL,
        url: url ? url : '',
        headers: headers,
        data: method === 'POST' || method === 'PUT' ? data : null,
        params: method === 'POST' || method === 'PUT' ? null : data,
    };

    return axios(config);
};

export default axiosInstance;
